import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { useCurrentPurchaseOrderContractTask } from '@/providers/PurchaseOrderContractTaskProvider';
import { PurchaseOrderContractTaskFileEditForm } from '@/components/features/tasks/purchase_order_contract/[purchase_order_contract_task_id]/PurchaseOrderContractTaskFileEditForm';

export const ApprovalPurchaseOrderContractTaskFiles = () => {
  const { _w_, _t_, me } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle(`Approval - Files`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `Approval`, path: `/w/${_w_!.identifier}/approval` },
        {
          label: `Approval - Purchase Order Contract Task Detail`,
          path: `/w/${_w_!.identifier}/approval/teams/${_t_!.id}/purchase_orders/${_po_!.id}/purchase_order_contract_tasks/${task!.id}`,
        },
      ]),
    []
  );

  const { _po_, mePurchaseOrderMember } = useCurrentPurchaseOrder();
  const { purchaseOrderContractTask: task } = useCurrentPurchaseOrderContractTask();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <PurchaseOrderContractTaskFileEditForm />
    </WorkspaceLayout>
  );
};
